import {AfterViewInit, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Photo} from '../../../../shared/models/cameralla-photo.model';
import {Location} from '@angular/common';
import {PhotoService} from '../../services/photo.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import * as $ from 'jquery';
import {RatingService} from '../../services/rating.service';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {CamerallaAuthService} from "../../../../shared/services/authentication-services/cameralla-auth.service";
import {FormGroup, FormGroupDirective, Validators} from "@angular/forms";
import {UserComments} from "../../services/user-comments.service";

@Component({
    selector: 'app-review-popup',
    templateUrl: './review-popup.component.html',
})
export class ReviewPopupComponent implements OnInit, AfterViewInit {
    @Input('photoDetails') photoDetails : Photo;
    @ViewChild('reviewForm') reviewForm: FormGroupDirective

    @Output() emitPreview = new EventEmitter<any[]>();

    static readonly criterionConst = ['general', 'vision', 'composition', 'cameraSettings', 'editing', 'presentation'];
    criterion = ReviewPopupComponent.criterionConst;
    reviewValid = true;
    ratingValid = true;
    maxLength = 1000;
    editableFeedback: any;
    selectedCriteria = this.criterion[0];
    isEdit: boolean;
    onSending:boolean = false;

    localUserId = null;

    public reviewObject:any = {};

    constructor(private location: Location,
                private photoService: PhotoService,
                private router: Router,
                private toastr: ToastrService,
                private userCommentsService: UserComments,
                private ratingService: RatingService,
                public activeModal: NgbActiveModal,
                private authService: CamerallaAuthService,) {
    }

    ngOnInit() {
        this.localUserId = +this.authService.getLocalUserInfo()['id'];
        //this.reviewObject = Photo.getDefaultOwnerRating(this.photoDetails.owner_rating);
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.reviewForm.form.get('general_text').setValidators([Validators.maxLength(this.maxLength)]);
        }, 1)

    }

    closePopUp() {
        this.activeModal.close();
    }

    setCommentView(criteria) {
        this.selectedCriteria = criteria;
        //this.commentCount();
    }

    submit() {
        this.onSending = true;
        const ratingObj = Object.assign({}, this.reviewObject);
        if (this.reviewObject.id) {
            this.ratingService.updateRating(ratingObj, ratingObj.id).toPromise().then(
                response => {
                    if (response['IsSuccess']) {
                        // Send notification for the user who relate to the conversation
                        if (this.photoDetails.owner_rating.general_text == null) {
                            this.sendNotification(response['Data'].owner_rating);
                        }

                        this.closePopUp();
                        this.photoDetails.owner_rating = response['Data'].owner_rating;
                        this.toastr.success('Photo has been updated successfully', 'DONE');
                    } else {
                        this.toastr.error('Something went wrong. Please try again later', 'ERROR');
                    }
                },
                error => {
                    this.onSending = false;
                    this.toastr.error(error.message, 'FAILED');
                }
            );
        } else {
            ratingObj.photoId = this.photoDetails.id;
            ratingObj.customerId =  this.authService.getLocalUserInfo()['id'];
            this.ratingService.ratePhoto(ratingObj).toPromise().then(
                response => {
                    if (response['IsSuccess']) {

                        // Send notification for the user who relate to the conversation
                        this.sendNotification(response['Data']['owner_rating']);
                        this.closePopUp();

                        this.photoDetails.commentsCount++;
                        this.photoDetails.owner_rating = response['Data'].owner_rating;
                        this.toastr.success('Feedback is now viewable on the photo detail page.', 'DONE');
                    } else {
                        this.toastr.error('Something went wrong. Please try again later', 'ERROR');
                    }
                },
                error => {
                    this.onSending = false;
                    this.toastr.error(error.message, 'FAILED');
                }
            );
        }
    }

    sendNotification(data) {
        const ratingData = {
            content: data.general_text,
            photoId: data.photoId,
            modelId: data.id
        };
        this.userCommentsService.sendMessage([], this.photoDetails['customer'], this.localUserId, ratingData, this.photoDetails['group']);
    }

}
